import { render, staticRenderFns } from "./Reviews.vue?vue&type=template&id=309b0b46&scoped=true&"
import script from "./Reviews.vue?vue&type=script&lang=js&"
export * from "./Reviews.vue?vue&type=script&lang=js&"
import style0 from "./Reviews.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Reviews.vue?vue&type=style&index=1&id=309b0b46&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309b0b46",
  null
  
)

/* custom blocks */
import block0 from "./Reviews.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./Reviews.vue?vue&type=custom&index=1&blockType=i18n&locale=ru&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
installComponents(component, {VCarousel,VCarouselItem})
